import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import AppSettingsTable from "src/components/app-settings/AppSettingsTable";
import EditSettingsDialog from "src/modal/EditSettingsDialog";
import ViewSettingsDialog from "src/modal/ViewSettingsDialog";
import { createBlobInContainer, STORAGE_URL } from "src/utils/azureBlob";
import { get, put } from "src/utils/networkUtils";

export default function AppSettingsPage() {
	const [, setLoading] = useState(false);
	const [rows, setRows] = useState(null);
	const [settings, setSettings] = useState(null);
	const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
	const [updateSettings, setUpdateSettings] = useState(null);
	const [openViewDialog, setOpenViewDialog] = useState(false);
	const [viewSettings] = useState({
		settingsType: "",
		settings: "",
	});

	useEffect(() => {
		get(`/admin/app-settings`).then((response) => {
			setRows(response.setingsTypes);
			setSettings(response.settings);
		});
	}, []);

	const updateSettingsHandler = () => {
		setLoading(true);
		setOpenUpdateDialog(false);
		put(`/admin/app-settings`, updateSettings).then(() => {
			window.location.reload(true);
		});
	};

	const handleOpenUpdateDialog = (settingsType) => {
		const typeSettings = settings.find((item) => item.settingsType === settingsType);
		let defaultSettings: any = Array.from({ length: 7 }, (_, i) => ({
			day: i + 1,
			amount: 20,
		}));

		if (settingsType === 1) {
			defaultSettings = { coinsReward: 0 };
		} else if (settingsType === 2) {
			defaultSettings = {
				coinsReward: 0,
				minDuration: 0,
			};
		}

		console.log("Type Settings:", typeSettings);

		setUpdateSettings({
			settingsType,
			settings: JSON.stringify(typeSettings?.settings ? JSON.parse(typeSettings.settings) : defaultSettings, null, 2),
		});

		setOpenUpdateDialog(true);
	};

	const updateComponentHandler = (row) => {
		console.log("Updated app component", row);
		setUpdatingComponent(row.AppComponentId);
		put(`/admin/app-components`, row)
			.then((response) => {
				setUpdatingComponent(null);
				get(`/admin/app-components`).then((response) => {
					setComponentRows(response.appComponents);
					setComponents(response.componentTypes);
				});
			})
			.catch((error) => {
				setUpdatingComponent(null);
				console.error("Error updating component:", error);
			});
	};

	const uploadFiles = (event, rowIndex) => {
		if (event.target.files.length > 0) {
			const files = event.target.files;

			const uploadPromises = [];
			uploadPromises.push(createBlobInContainer(files[0]));

			if (uploadPromises.length > 0) {
				const uploadFiles = async () => {
					await Promise.all(uploadPromises);
					const imageUrl = `${STORAGE_URL}/${files[0].name}`;

					const updatedRows = [...componentRows];
					updatedRows[rowIndex].ImageUrl = imageUrl;
					setComponentRows(updatedRows);
				};

				uploadFiles().catch(console.error);
			}
		}
	};

	return (
		<>
			<Helmet>
				<title> App Settings </title>
			</Helmet>

			<AppSettingsTable rows={rows} settings={settings} handleOpenUpdateDialog={handleOpenUpdateDialog} />

			<ViewSettingsDialog
				open={openViewDialog}
				onClose={() => setOpenViewDialog(false)}
				settingsType={viewSettings.settingsType}
				settings={viewSettings.settings}
			/>

			{openUpdateDialog && (
				<EditSettingsDialog
					open={openUpdateDialog}
					onClose={() => setOpenUpdateDialog(false)}
					updateSettings={updateSettings}
					setUpdateSettings={setUpdateSettings}
					updateSettingsHandler={updateSettingsHandler}
				/>
			)}
		</>
	);
}
